// frontend/src/api/products/productsApi.js

import axiosClient from '../axiosClient';

export const productsApi = {
  /**
   * Get paginated products with filters
   */
  getProducts: async (page, size, search, category, stock, sortBy, sortOrder) => {
    try {
      const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
        sortOrder: sortOrder || 'desc'
      });

      if (search) params.append('search', search);
      if (category) params.append('category', category);
      if (stock && stock !== 'all') params.append('stock', stock);
      if (sortBy) params.append('sortBy', sortBy);

      console.log('📡 Calling products API with params:', params.toString());

      const data = await axiosClient.get(`/products?${params.toString()}`);
      
      console.log('✅ Products API Response:', data);
      return data;
    } catch (error) {
      console.error('❌ Error in getProducts:', error);
      throw error;
    }
  },

  /**
   * Search products for suggestions (CAT No, Item Name, CAS No)
   */
  searchProducts: async (query) => {
    try {
      console.log('📡 Calling search products API with query:', query);

      const params = new URLSearchParams({
        query: query
      });

      const data = await axiosClient.get(`/products/search?${params.toString()}`);
      
      console.log('✅ Search Products API Response:', data.length, 'results');
      return data;
    } catch (error) {
      console.error('❌ Error in searchProducts:', error);
      throw error;
    }
  },

  /**
   * Get product details by item code
   */
  getProductDetails: async (itemCode) => {
    try {
      console.log('📡 Calling product details API for:', itemCode);

      const data = await axiosClient.get(`/products/detail/${encodeURIComponent(itemCode)}`);
      
      console.log('✅ Product Details API Response:', data);
      return data;
    } catch (error) {
      console.error('❌ Error in getProductDetails:', error);
      throw error;
    }
  },

  /**
   * Get stock locations for a product
   */
  getStockLocations: async (itemCode) => {
    try {
      console.log('📡 Calling stock locations API for:', itemCode);

      const data = await axiosClient.get(`/products/stock-locations/${encodeURIComponent(itemCode)}`);
      
      console.log('✅ Stock Locations API Response:', data.length, 'records');
      return data;
    } catch (error) {
      console.error('❌ Error in getStockLocations:', error);
      throw error;
    }
  },

  /**
   * Get top customers for a product
   */
  getTopCustomers: async (itemCode) => {
    try {
      console.log('📡 Calling top customers API for:', itemCode);

      const data = await axiosClient.get(`/products/top-customers/${encodeURIComponent(itemCode)}`);
      
      console.log('✅ Top Customers API Response:', data.length, 'records');
      return data;
    } catch (error) {
      console.error('❌ Error in getTopCustomers:', error);
      throw error;
    }
  },

  /**
   * Get monthly sales for a product by financial year
   */
  getMonthlySalesByFinancialYear: async (itemCode, startYear) => {
    try {
      console.log('📡 Calling monthly sales API for:', itemCode, 'FY Start Year:', startYear);

      const params = new URLSearchParams({
        startYear: startYear.toString()
      });

      const data = await axiosClient.get(`/products/monthly-sales-fy/${encodeURIComponent(itemCode)}?${params.toString()}`);
      
      console.log('✅ Monthly Sales FY API Response:', data.length, 'records');
      return data;
    } catch (error) {
      console.error('❌ Error in getMonthlySalesByFinancialYear:', error);
      throw error;
    }
  },

  /**
   * Export all products with filters
   */
  exportProducts: async (search, category, stock) => {
    try {
      const params = new URLSearchParams();

      if (search) params.append('search', search);
      if (category) params.append('category', category);
      if (stock && stock !== 'all') params.append('stock', stock);

      console.log('📊 Exporting products with params:', params.toString());

      const data = await axiosClient.get(`/products/export?${params.toString()}`);
      
      console.log('✅ Export API Response:', data.length, 'records');
      return data;
    } catch (error) {
      console.error('❌ Error in exportProducts:', error);
      throw error;
    }
  },

  /**
   * Get all categories
   */
  getCategories: async () => {
    try {
      console.log('📡 Calling categories API');

      const data = await axiosClient.get('/products/categories');
      
      console.log('✅ Categories API Response:', data.length, 'categories');
      return data;
    } catch (error) {
      console.error('❌ Error in getCategories:', error);
      throw error;
    }
  },
};